function InitTooltip() {
    function toggleVisibility(tooltipContent, visibility) {
        tooltipContent.classList.toggle('hidden', visibility)
    }

    document.querySelectorAll('[data-tooltip]').forEach(function (qualityContainer) {
        const tooltipController = qualityContainer.querySelector('[data-tooltip__controller]');
        if(!!tooltipController) {
            const tooltipContent = qualityContainer.querySelector('[data-tooltip__content]')
            let isHovered = false

            tooltipController.onclick = () => {
                if (!isHovered) toggleVisibility(tooltipContent)
            }

            tooltipController.onmouseover = () => {
                isHovered = true
                toggleVisibility(tooltipContent, false)
            }

            tooltipController.onmouseleave = () => {
                isHovered = false
                toggleVisibility(tooltipContent)
            }
        }
    })
}

export default function() {
    InitTooltip()
}
